module.exports = __webpack_public_path__ + "static/footer-5-f307f5f86fd1e852dcb3b49306db7cfc.mp4";